import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { ManualInvoiceType } from "../../utils/Utils";
const ManualInvoiceDropDown = ({ value, onSelect, placeholder, ...props }) => {
  const [list, setList] = useState();

  useEffect(() => {
    const InvoiceTypeOptions = [
      { id: 1, label: "Create Invoice", value: ManualInvoiceType.createInvoice },
      { id: 2, label: "Download Invoice", value: ManualInvoiceType.downloadInvoice },
      { id: 3, label: "Download Credit Note", value: ManualInvoiceType.downloadCreditNote },
    ];
    setList(InvoiceTypeOptions);
    return () => {
      setList();
    };
  }, []);

  return (
    <RSelect
      options={list ?? []}
      placeholder={placeholder}
      value={value ?? null}
      onChange={(e) => {
        onSelect(e);
      }}
      {...props}
    />
  );
};

export default ManualInvoiceDropDown;
